import React from 'react';
import { Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import { connect } from 'react-redux';

// Scripts
let dateFormatter = require('../../tools/formatters/dateFormatter');

// Variables
let tableColumnsList = [
    {
        title: "Estado",
        key: "status",
        style: { textAlign: "center", width: 80 }
    },
    {
        title: "Fuente de descarga",
        key: "description",
        style: { textAlign: "center" }
    },
    {
        title: "Fecha",
        key: "date",
        style: { textAlign: "left" }
    },
    {
        title: "Tipo",
        key: "type_description",
        style: { textAlign: "center" }
    },
    {
        title: "Detalle",
        key: "detail",
        style: { textAlign: "center" }
    }
];

const paginationSize = 5;

class AlertsResumeTable extends React.Component {
    constructor() {
        super();

        this.state = {
            alerts: [],
            sortingActiveKey: "",
            sortingActiveDirection: "",
            isModalOpen: false,
            selectedAlert: null
        };
    }

    toggleModal = (alert = null) => {
        this.setState({
            isModalOpen: !this.state.isModalOpen,
            selectedAlert: alert
        });
    }

    render() {
        const { isLoading, error } = this.props;

        return (
            <React.Fragment>
                <h4 className="mb-4">Historial de Alertas</h4>
                
                {isLoading ? (
                    <div className="text-center my-4">
                        <Spinner color="primary" />
                        <p className="mt-2">Cargando alertas...</p>
                    </div>
                ) : error ? (
                    <div className="text-center my-4 text-danger">
                        <i className="fas fa-exclamation-circle mr-2" />
                        <p>{error}</p>
                    </div>
                ) : (
                    <React.Fragment>
                        <Table>
                            {this.getTableHeaders()}
                            <tbody>
                                {this.getTableRows()}
                            </tbody>
                        </Table>

                        <hr style={{ marginTop: 0 }} />

                        <div style={{ display: "flex", textAlign: "center" }}>
                            <div style={{ flex: "50%", display: "flex", justifyContent: "flex-start" }}>
                                <Button style={{ marginLeft: 5, marginRight: 5 }} outline color="success"
                                    disabled={(this.props.activeQuantity >= this.state.alerts.length)}
                                    onClick={() => {
                                        this.props.updateActiveQuantity(this.state.alerts.length);
                                    }}>Ver todo</Button>
                            </div>

                            <div style={{ flex: "50%", display: "flex", justifyContent: "flex-end" }}>
                                <Button style={{ marginLeft: 5, marginRight: 5 }}
                                    disabled={(this.props.activeQuantity <= paginationSize)}
                                    onClick={() => {
                                        if (!(this.props.activeQuantity <= paginationSize)) {
                                            this.props.updateActiveQuantity(this.props.activeQuantity - paginationSize);
                                        }
                                    }}>Ver menos
                                </Button>

                                <Button color="info" style={{ marginLeft: 5, marginRight: 5 }}
                                    disabled={(this.props.activeQuantity > this.state.alerts.length)}
                                    onClick={() => {
                                        if (!(this.props.activeQuantity > this.state.alerts.length)) {
                                            this.props.updateActiveQuantity(this.props.activeQuantity + paginationSize);
                                        }
                                    }}>Ver más
                                </Button>
                            </div>
                        </div>
                    </React.Fragment>
                )}

                {/* Differences Detail Modal */}
                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal} size="md">
                    <ModalHeader toggle={this.toggleModal}>
                        {this.state.selectedAlert && (
                            <span>Detalle de Alerta - {this.state.selectedAlert.description}</span>
                        )}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.selectedAlert && (
                            <div className="differences-container">
                                {this.renderDifferences(this.state.selectedAlert.differences)}
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleModal}>Cerrar</Button>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }

    // Format and render differences with proper styling
    renderDifferences = (differencesText) => {
        if (!differencesText) {
            return <p>No hay detalles disponibles</p>;
        }

        // Check if it's a URL
        if (differencesText.startsWith('URL:')) {
            const url = differencesText.replace('URL:', '').trim();
            return (
                <div style={{ 
                    padding: '1rem', 
                    borderRadius: '4px', 
                    backgroundColor: '#f8f9fa'
                }}>
                    <p>URL: <a href={url} target="_blank" rel="noopener noreferrer">{url}</a></p>
                </div>
            );
        }
        
        // Check if it contains + or - characters (likely a diff)
        const containsDiff = differencesText.includes('+') || differencesText.includes('-');
        
        if (!containsDiff) {
            // If it's just plain text, display it normally
            return (
                <div style={{ 
                    padding: '1rem', 
                    borderRadius: '4px', 
                    backgroundColor: '#f8f9fa',
                    whiteSpace: 'pre-wrap' 
                }}>
                    {differencesText}
                </div>
            );
        }
        
        // Process as diff - split by line breaks
        const lines = differencesText.split('\n');
        
        return (
            <div style={{ 
                fontFamily: 'monospace', 
                backgroundColor: '#f8f9fa', 
                padding: '1rem', 
                borderRadius: '4px', 
                whiteSpace: 'pre-wrap' 
            }}>
                {lines.map((line, index) => {
                    if (line.startsWith('+')) {
                        // Added line
                        return (
                            <div key={index} style={{ backgroundColor: '#e6ffed', color: '#22863a' }}>
                                {line}
                            </div>
                        );
                    } else if (line.startsWith('-')) {
                        // Removed line
                        return (
                            <div key={index} style={{ backgroundColor: '#ffeef0', color: '#cb2431' }}>
                                {line}
                            </div>
                        );
                    } else {
                        // Context line
                        return <div key={index}>{line}</div>;
                    }
                })}
            </div>
        );
    }

    componentDidMount() {
        this.setState({ alerts: this.props.alerts || [] });
    }

    componentDidUpdate() {
        if (JSON.stringify(this.state.alerts) !== JSON.stringify(this.props.alerts)) {
            this.setState({ alerts: this.props.alerts });
        }
    }

    // Rendering methods
    getStatusIcon = (status) => {
        if (status === 'WARNING') {
            return <div className="icon-big text-center">
                <i className="fas fa-exclamation-triangle" style={{ color: "#ffc107" }} />
            </div>;
        } else if (status === 'DANGER') {
            return <div className="icon-big text-center">
                <i className="fas fa-exclamation-circle" style={{ color: "#dc3545" }} />
            </div>;
        }
        return null;
    }

    getDateLabel = (alert) => {
        return (
            <React.Fragment>
                <p style={{ marginBottom: 0, paddingLeft: 0 }}>
                    {dateFormatter.getShortDate(new Date(alert.date))}
                </p>
                <p className="category" style={{ marginBottom: 0, textTransform: "none", paddingLeft: 0 }}>
                    {dateFormatter.getShortHour(new Date(alert.date))}
                </p>
            </React.Fragment>
        );
    }

    getTableHeaders = () => {
        let headersList = [];
        let sortingIcon = undefined;

        for (let i = 0; i < tableColumnsList.length; i++) {
            if (tableColumnsList[i].key === this.state.sortingActiveKey) {
                if (this.state.sortingActiveDirection === "asc") {
                    sortingIcon = <span><i className={"nc-icon nc-minimal-down"} style={{ marginLeft: 4 }}></i></span>;
                } else {
                    sortingIcon = <span><i className={"nc-icon nc-minimal-up"} style={{ marginLeft: 4 }}></i></span>;
                }
            } else {
                sortingIcon = null;
            }

            headersList.push(
                <th style={{ ...tableColumnsList[i].style, fontSize: 10 }} key={"alertsHeader." + i} className="noselect">
                    <p style={{ marginBottom: 0, cursor: "pointer" }}
                        onClick={() => { this.sortAlertsBasedOnKey(tableColumnsList[i].key) }}>
                        {tableColumnsList[i].title}
                        {sortingIcon}
                    </p>
                </th>
            );
        }

        return (
            <thead className="muted-text">
                <tr>
                    {headersList}
                </tr>
            </thead>
        );
    }

    getTableRows = () => {
        if (this.state.alerts.length === 0) {
            return (
                <tr>
                    <td colSpan={tableColumnsList.length} className="text-center">
                        <p className="mt-3 mb-3">
                            No hay alertas que mostrar. Por favor seleccione al menos una fuente de descarga y tipo de alerta.
                        </p>
                    </td>
                </tr>
            );
        }

        let rowsList = [];

        for (let i = 0; i < this.state.alerts.length && i < this.props.activeQuantity; i++) {
            const alert = this.state.alerts[i];
            
            rowsList.push(
                <tr key={"alertRow." + i}>
                    <td style={{ padding: 0 }}>
                        {this.getStatusIcon(alert.status)}
                    </td>

                    <td>
                        <p style={{ marginBottom: 0 }}>
                            <b>{alert.description}</b>
                        </p>
                    </td>

                    <td style={{ textAlign: "left" }}>
                        {this.getDateLabel(alert)}
                    </td>

                    <td style={{ textAlign: "center" }}>
                        <p>{alert.type_description}</p>
                    </td>

                    <td style={{ textAlign: "center" }}>
                        <Button 
                            color="primary" 
                            size="sm" 
                            onClick={() => this.toggleModal(alert)}
                            disabled={!alert.differences}
                        >
                            Detalle
                        </Button>
                    </td>
                </tr>
            );
        }

        return rowsList;
    }

    // Operational methods
    sortAlertsBasedOnKey = (key) => {
        if (key !== "detail") {
            let sortedAlertsList = [];
            let originalAlertsList = this.state.alerts;

            if (key !== this.state.sortingActiveKey) {
                sortedAlertsList = originalAlertsList.sort((a, b) => a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);

                this.setState({
                    sortingActiveKey: key,
                    sortingActiveDirection: "asc",
                    alerts: sortedAlertsList
                });
            } else {
                if (this.state.sortingActiveDirection !== "asc") {
                    sortedAlertsList = originalAlertsList.sort((a, b) => a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);

                    this.setState({
                        sortingActiveKey: key,
                        sortingActiveDirection: "asc",
                        alerts: sortedAlertsList
                    });
                } else {
                    sortedAlertsList = originalAlertsList.sort((a, b) => a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0);

                    this.setState({
                        sortingActiveKey: key,
                        sortingActiveDirection: "des",
                        alerts: sortedAlertsList
                    });
                }
            }
        }
    }
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser
    };
};

export default connect(mapStateToProps)(AlertsResumeTable);